import React from 'react'
import { Grid, Icon, IconButton, makeStyles, Paper, Table, TableBody, TableCell, TableHead, TableRow, withStyles } from '@material-ui/core'
import DisplayText from '../../../../components/Texts/DisplayText'
import { onFormatNumber, onGetFullName } from '../../../../shared/utility'
import NumberAvatar from '../../../../components/DisplayData/NumberAvatar'
import StatusLabel from '../../../../components/DisplayData/StatusLabel'
import { blueGrey, grey } from '@material-ui/core/colors'
import SearchBar from './SearchBar'
import FilterButton from './FilterButton'
import { generalCatalogs } from '../../../../variables/catalogs'
import ActionBar from './ActionBar'
import UserStatusLabel from '../../../../components/DisplayData/UserStatusLabel'
import UserAvatarName from '../../../../components/DisplayData/UserAvatarName'

const userTypesCatalog = [{id:-1, value:-1, label:'Todos'}, ...generalCatalogs.user_types ]
const statusCatalog = [{id:-1, value:-1, label:'Todos'}, {id:1, value:1, label:'Activo'},{id:0, value:0, label:'Inactivo'}]
const searchCatalog = [{id:1, value:'first_name', label:'Nombre '},{id:2, value:'username', label:'Usuario'}]

const header = [
    {id:1, label:'ID'},
    {id:2, label:'Nombre'},
    {id:3, label:'Usuario'},
    {id:4, label:'Nivel'},
    {id:5, label:'Email'},
    {id:5, label:'Estatus'},
]


const useStyles = makeStyles(theme => ({
    root:{},
    paper:{
        borderRadius:16,
        boxShadow:'0 10px 24px 0 rgba(82, 91, 115, .12)'
    },
    cell:{
        borderColor:grey[200],
    },
    row:{
        '&:hover':{
            cursor:'pointer',
            background:grey[100]
        }
    },
    cellHeader:{
        borderColor:grey[200],
        paddingTop:12,
        paddingBottom:8
    },
    button:{
        background:theme.palette.primary.main,
        color:'white',
        '&:hover':{
            background:theme.palette.primary.dark,
        }
    },
    toolbar:{
        marginBottom:16
    },
    actions:{
        marginTop:16
    },
    table:{
        minWidth:800
    },
    tableWrapper:{
        overflowX: 'auto',
    },
}))

const SimpleTable = props => {

    const classes = useStyles()
    const {data, onAddRegister, filter, onChangeFilter, total, tableFilter, onUpdateTableFilter, onSelectedItem} = props

    return(
        <div>
            <div className={classes.toolbar}>
                <Grid container justify='flex-end' spacing={2} alignItems='flex-end' > 
                    <Grid item>
                        <FilterButton label='Nivel' onChange={(id) => onChangeFilter('user_type_id', id)}
                        options={userTypesCatalog} selected={filter.user_type_id}/>
                    </Grid>
                    <Grid item>
                        <FilterButton label='Estatus' onChange={(id) => onChangeFilter('status', id)}
                        options={statusCatalog} selected={filter.status}/>
                    </Grid>
                    <Grid item>
                        <Grid container wrap='nowrap' spacing={2} alignItems='flex-end'>
                            <Grid item>
                                <FilterButton label='Buscar por' onChange={(id) => onChangeFilter('search_by', id)}
                                options={searchCatalog} selected={filter.search_by}/>
                            </Grid>
                            <Grid item><SearchBar value={filter.query} onChange={(value) => onChangeFilter('query', value)} /></Grid>
                            <Grid item><IconButton className={classes.button} onClick={onAddRegister}><Icon>add</Icon></IconButton></Grid>
                        </Grid>
                    </Grid>
                    
                </Grid>
            </div>
            <Paper className={classes.paper}>
                {data && data.length ? (
                    <div className={classes.tableWrapper}>
                        <Table className={classes.table}>
                            {header ? (
                                <TableHead>
                                    <TableRow>
                                        {header.map(item=>{
                                            return(
                                                <TableCell padding={item.id === 1 ? 'default' : 'default'} className={classes.cellHeader} key={item.id.toString()}>
                                                    <DisplayText variant='subtitle1' >{item.label}</DisplayText>
                                                </TableCell>
                                            )
                                        })}
                                    </TableRow>
                                </TableHead>
                            ):null}
                            <TableBody>
                                {data.map((item,key) => {
                                    const {id_user, first_name, last_name, username, user_type, email, status, image,
                                        trf, test_result, benefit_level, patient_status, patient_status_id} = item

                                    const fullname = onGetFullName(first_name, last_name)

                                    return(
                                        <TableRow key={key.toString()} className={classes.row} onClick={() => onSelectedItem(item)}>
                                            <TableCell className={classes.cell}><DisplayText>{id_user}</DisplayText></TableCell>
                                            <TableCell className={classes.cell}><UserAvatarName name={fullname} image={image}/></TableCell>
                                            <TableCell className={classes.cell}><DisplayText>{username}</DisplayText></TableCell>
                                            <TableCell className={classes.cell}><DisplayText >{user_type}</DisplayText></TableCell>
                                            <TableCell className={classes.cell}><DisplayText >{email}</DisplayText></TableCell>
                                            <TableCell className={classes.cell}><UserStatusLabel status={status} /></TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </div>
                    
                ): null}
            </Paper>
            <div className={classes.actions}>
                <ActionBar total={total} tableFilter={tableFilter} onUpdateTableFilter={onUpdateTableFilter}/>
            </div>
        </div>
    )
}

export default SimpleTable